export const serviceRequestTypes = {
  Generic: 0,
  AddDriver: 1,
  ReplaceDriver: 2,
  RemoveDriver: 3,
  AddressChange: 4,
  VehicleTransfer: 5,
  CertificateOfInsurance: 6,
  PolicyChangeRequestOther: 7,
  GeneralNew: 8,
  AddVehicle: 9,
  ReplaceVehicle: 10,
};

export const getServiceRequestNames = [
  { key: serviceRequestTypes.Generic, name: 'General' },
  { key: serviceRequestTypes.AddDriver, name: 'Add Driver' },
  { key: serviceRequestTypes.ReplaceDriver, name: 'Replace Driver' },
  { key: serviceRequestTypes.RemoveDriver, name: 'Remove Driver' },
  { key: serviceRequestTypes.AddVehicle, name: 'Add Vehicle' },
  { key: serviceRequestTypes.ReplaceVehicle, name: 'Replace Vehicle' },
  { key: serviceRequestTypes.AddressChange, name: 'Address Change' },
  { key: serviceRequestTypes.VehicleTransfer, name: 'Vehicle Transfer' },
  { key: serviceRequestTypes.CertificateOfInsurance, name: 'Certificate of Insurance' },
  { key: serviceRequestTypes.PolicyChangeRequestOther, name: 'Policy Change Request - Other' },
  { key: serviceRequestTypes.GeneralNew, name: 'GeneralNew' },
];
